import "./Login2.css";
import Logo from "../../icons/gnai_logo.svg";
import loginImage from "../../icons/login_Illustration.svg";
import swal from "sweetalert";
import React from "react";
import { setSessionToken, setUser, setLoggedIn } from "../Protected";
import { identifyClarityUser } from "../../helpers/clarity";
import { identifyPostHogUser } from "../../helpers/posthog";
import Loading from "../../components/Loading";
import OTPInput from "react-otp-input";
import { login, verifyOtp } from "../../Rest_api/RestApi";
import { Link, useNavigate } from "react-router-dom";
import { DisclamerModel } from "../../layout/Sidebar2";
import { useDispatch } from "react-redux";
import { setIsOpen } from "../../store/state/disclamerModel";

export function Login2() {
  const [otpSent, setOtpSent] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [email, setEmail] = React.useState<string>("");
  let [otp, setOtp] = React.useState<number>();
  const [otpSecondsRemaining, setOtpSecondsRemaining] =
    React.useState<number>(0);
  const [resendSecondsRemaining, setResendSecondsRemaining] =
    React.useState<number>(0);
  const [hasResentOnce, setHasResentOnce] = React.useState<boolean>(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const OTP_EXPIRY_SECONDS = 300; // 5 minutes, aligned with backend
  const RESEND_COOLDOWN_SECONDS = 30; // Allow resend after 30s

  const isValidEmail = (value: string) => {
    // Basic RFC 5322 compliant-ish regex suitable for most cases
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    return emailRegex.test(value.trim());
  };

  React.useEffect(() => {
    if (!otpSent) return;
    if (otpSecondsRemaining <= 0) return;
    const interval = setInterval(() => {
      setOtpSecondsRemaining((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, [otpSent, otpSecondsRemaining]);

  React.useEffect(() => {
    if (!otpSent) return;
    if (resendSecondsRemaining <= 0) return;
    const interval = setInterval(() => {
      setResendSecondsRemaining((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, [otpSent, resendSecondsRemaining]);

  return (
    <div className="login-container flex flex-col md:flex-row justify-center gap-10 items-center">
      {loading && <Loading />}

      <div className="w-full md:w-[50%]">
        <div className="left-container gap-10">
          {!otpSent ? (
            <div className="login-box">
              <div className="flex justify-center items-center flex-col gap-3 mb-6">
                <img src={Logo} width={120} alt="GNA" />
              </div>
              <div className="login-box-header gap-2">
                <h1 className="text-gray-500 font-medium">Sign in</h1>
                <p className="">To Your Dashboard</p>
                <p
                  className="text-xs font-semibold leading-none"
                  style={{
                    fontFamily: "Marsden Wide",
                    fontSize: "12px",
                    lineHeight: "100%",
                    letterSpacing: "0%",
                  }}
                >
                  GNAi <span style={{ color: "#F1935C" }}>|</span> Electricity
                  Derivatives
                </p>
              </div>
              <form className="login-form" onSubmit={handleFormSubmit}>
                <label>Email</label>
                <input
                  type="text"
                  placeholder="user@example.com"
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                />
                <button className="" type="submit" value="Sign in">
                  Submit
                </button>
              </form>
              <div
                className="login-box-footer"
                onClick={() => {
                  swal(
                    "",
                    "Please write to info@gna.energy to register for this platform.",
                    "warning",
                  );
                }}
              >
                Don't Have an Account? <span>Register</span>
              </div>

              <p className="text-center mt-5 agreement">
                By creating an account or continuing by logging in, you agree to
                our{" "}
                <Link to={""} onClick={() => dispatch(setIsOpen(true))}>
                  T&C{" "}
                </Link>{" "}
                & <Link to={""}>Privacy Policy</Link>
              </p>

              <DisclamerModel />

              <div className="mt-8 text-center">
                <p className="">Developed by</p>
                <p className="mt-1 text-[1rem]">
                  GNA Energy Data & Analytics Capability Center
                </p>
              </div>
            </div>
          ) : (
            // For Otp Verification
            <div className="login-box">
              <div className="login-box-header">
                <h1>OTP</h1>
                <p>{email}</p>
              </div>
              <form className="login-form" onSubmit={handleFormSubmit}>
                <label>Enter the OTP</label>
                <OTPInput
                  inputType="number"
                  value={otp?.toString()}
                  onChange={(value) => {
                    console.log(value);
                    const numeric = value.replace(/[^0-9]/g, "");
                    if (numeric.length === 0) {
                      setOtp(undefined as any);
                    } else {
                      setOtp(parseInt(numeric));
                    }
                  }}
                  numInputs={5}
                  renderSeparator={<span>&nbsp;&nbsp;&nbsp;&nbsp;</span>}
                  renderInput={(props) => <input {...props} />}
                />
                {otpSecondsRemaining > 0 ? (
                  <div className="text-xs text-gray-500 mt-2">
                    OTP expires in{" "}
                    <span className="font-semibold text-red-500">
                      {Math.floor(otpSecondsRemaining / 60)
                        .toString()
                        .padStart(1, "0")}
                      :{(otpSecondsRemaining % 60).toString().padStart(2, "0")}
                    </span>
                  </div>
                ) : (
                  <div className="text-xs text-red-500 mt-2">OTP expired</div>
                )}
                <button type="submit" value="otpsubmit">
                  Submit
                </button>
              </form>
              <div className="mt-2 flex items-center gap-2">
                {hasResentOnce && resendSecondsRemaining > 0 ? (
                  <span className="text-[10px] leading-none text-gray-500">
                    Resend again in {Math.floor(resendSecondsRemaining / 60)}:
                    {(resendSecondsRemaining % 60).toString().padStart(2, "0")}
                  </span>
                ) : (
                  <button
                    className="text-xs text-gray-500 bg-transparent p-0 disabled:text-gray-400"
                    disabled={loading}
                    onClick={async () => {
                      if (!email || !isValidEmail(email)) {
                        swal(
                          "Invalid email",
                          "Please enter a valid email address.",
                          "warning",
                        );
                        return;
                      }
                      try {
                        setLoading(true);
                        const response = await login(email);
                        if (response?.status === true) {
                          setOtp(undefined as any);
                          setOtpSecondsRemaining(OTP_EXPIRY_SECONDS);
                          // First resend is free; subsequent resends use cooldown
                          if (!hasResentOnce) {
                            setHasResentOnce(true);
                            setResendSecondsRemaining(RESEND_COOLDOWN_SECONDS);
                          } else {
                            setResendSecondsRemaining(RESEND_COOLDOWN_SECONDS);
                          }
                          swal(
                            "OTP resent",
                            "A new OTP has been sent to your email.",
                            "success",
                          );
                        } else {
                          swal(
                            "",
                            response?.message || "Unable to resend OTP.",
                            "warning",
                          );
                        }
                      } catch (err: any) {
                        const errorMessage =
                          err?.message ||
                          "Unable to resend OTP. Please try again.";
                        swal("Error", errorMessage, "warning");
                      } finally {
                        setLoading(false);
                      }
                    }}
                  >
                    Resend OTP
                  </button>
                )}
              </div>
              <div
                className="login-box-footer"
                onClick={() => {
                  setOtpSent(false);
                  setOtp(null as any);
                  setOtpSecondsRemaining(0);
                  setResendSecondsRemaining(0);
                  setHasResentOnce(false);
                }}
              >
                Go Back
              </div>

              <div className="mt-8 text-center">
                <p className="">Developed by</p>
                <p className="mt-1 text-[1rem]">
                  GNA Energy Data & Analytics Capability Center
                </p>
              </div>
            </div>
          )}

          <div className="copyright md:absolute md:bottom-5">
            © 2025, GNA Energy Private Limited All Rights Reserved
          </div>
        </div>
      </div>

      <div className="hidden md:block w-[50%]">
        <img
          src={loginImage}
          alt="GNAI Illustration"
          className="w-full h-full"
        />
      </div>
    </div>
  );

  async function handleFormSubmit(e: any) {
    try {
      e.preventDefault();
      if (otpSent) {
        if (!otp || otp?.toString().length !== 5) {
          swal("Invalid OTP", "Please enter a 5-digit OTP.", "warning");
          return;
        }
        if (otpSecondsRemaining <= 0) {
          swal("OTP expired", "Please resend OTP and try again.", "warning");
          return;
        }
        await handleOtpSubmit();
        return;
      }
      if (!email || email.trim() === "") {
        swal("Email required", "Please enter your email ID.", "warning");
        return;
      }
      if (!isValidEmail(email)) {
        swal("Invalid email", "Please enter a valid email address.", "warning");
        return;
      }
      setLoading(true);
      const response = await login(email);

      console.log(response);
      if (response.status === true) {
        setOtpSent(true);
        setOtpSecondsRemaining(OTP_EXPIRY_SECONDS);
        // First resend should be free: do not start cooldown here
        setResendSecondsRemaining(0);
        setHasResentOnce(false);
      } else {
        swal("", response.message || "Unable to send OTP. Please try again.", "warning");
      }
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      const errorMessage =
        e?.message ||
        "Unable to send OTP. Please check your email and try again.";
      swal("Error", errorMessage, "warning");
    }
  }

  async function handleOtpSubmit() {
    try {
      if (otp?.toString().length !== 5) {
        return;
      }
      setLoading(true);

      const response = await verifyOtp(email, otp?.toString()!);
      console.log(response);
      if (response.status === true) {
        setLoading(false);

        setSessionToken(response.token);
        setUser({
          email: email,
          accessToken: response.token,
        });
        setLoggedIn(true);
        identifyClarityUser(email);
        identifyPostHogUser(email);

        // Get the intended URL from localStorage
        const intendedUrl = localStorage.getItem("intendedUrl");
        console.log("Found intended URL:", intendedUrl);

        if (intendedUrl) {
          // Clear the stored URL
          localStorage.removeItem("intendedUrl");
          // Redirect to the intended URL
          window.location.href = intendedUrl;
        } else if (response.dashboard_type == "derivative") {
          window.location.href = "/derivative";
        } else {
          // Default redirect to dashboard
          window.location.href = "/dashboard";
        }
      } else {
        setLoading(false);
        swal(
          "Invalid or expired OTP",
          response.message ||
          "The OTP you entered is incorrect or has expired.",
          "warning",
        );
      }
    } catch (e: any) {
      setLoading(false);
      const errorMessage =
        e?.message || "Verification failed. Please try again.";
      swal("Error", errorMessage, "warning");
    }
  }
}
